module.exports = __webpack_public_path__ + "img/img.f248aa78.png";